import React, { useState, useEffect } from "react";
import { Box, Flex, Heading, Image, Text, VStack } from "@chakra-ui/react";

const slides = ["/basic_1.webp", "/basic_2.webp", "/basic_3.webp", "/basic_4.webp"];

export function SurveyLayout({ title, subtitle, tagline, children }) {
  const [aIndex, setAIndex] = useState(0);
  const [bIndex, setBIndex] = useState(1);
  const [showA, setShowA] = useState(true);

  useEffect(() => {
    const id = setInterval(() => {
      const next = ((showA ? aIndex : bIndex) + 1) % slides.length;
      if (showA) setBIndex(next);
      else setAIndex(next);
      setShowA((s) => !s);
    }, 8000);
    return () => clearInterval(id);
  }, [showA, aIndex, bIndex]);

  return (
    <Flex minH="100vh" w="100%">
      {/* LEFT: crossfading slideshow */}
      <Box flex="1" position="relative" display={{ base: "none", md: "block" }}>
        <Box position="absolute" inset={0}>
          <Box
            position="absolute"
            inset={0}
            backgroundImage={`url(${slides[aIndex]})`}
            backgroundSize="cover"
            backgroundPosition="center"
            transition="opacity 1.2s ease"
            opacity={showA ? 1 : 0}
            filter="brightness(1.15) contrast(1.05)"
          />
          <Box
            position="absolute"
            inset={0}
            backgroundImage={`url(${slides[bIndex]})`}
            backgroundSize="cover"
            backgroundPosition="center"
            transition="opacity 1.2s ease"
            opacity={showA ? 0 : 1}
            filter="brightness(1.15) contrast(1.05)"
          />
          <Box
            position="absolute"
            inset={0}
            bgGradient="linear(to-b, rgba(255,255,255,0.12), rgba(0,0,0,0.35))"
          />
          {tagline && (
            <Box
              position="absolute"
              top="5%"
              left="50%"
              transform="translateX(-50%)"
              width="100%"
              textAlign="center"
            >
              <Flex align="center" justify="center" width="100%" height="100%" px="5%">
                <Text
                  fontFamily="Georgia, 'Times New Roman', serif"
                  fontStyle="italic"
                  mb={2}
                  color="white"
                  fontSize={{ base: "2xl", md: "4xl", lg: "5xl" }}
                  fontWeight="bold"
                  lineHeight="short"
                  maxW="1200px"
                  textAlign="center"
                >
                  {tagline}
                </Text>
              </Flex>
            </Box>
          )}
        </Box>
      </Box>

      {/* RIGHT: form panel */}
      <Flex flex="1" direction="column" position="relative" h="100vh" overflow="hidden">
        <Box position="absolute" inset={0} bg="#3a1714" zIndex={-2} pointerEvents="none" />
        <Box
          position="absolute"
          inset={0}
          zIndex={-2}
          pointerEvents="none"
          bgGradient="linear(to-b, rgba(58, 23, 20,0.8) 0%, rgba(58, 23, 20,0.7) 40%, rgba(58, 23, 20,0.4) 80%, rgba(58, 23, 20,0.7) 100%)"
        />
        <Box
          position="absolute"
          inset={0}
          backgroundImage="url('/grain.png')"
          backgroundRepeat="repeat"
          opacity={0.1}
          zIndex={-1}
          pointerEvents="none"
        />

        {/* Fixed header */}
        <VStack
          spacing={3}
          textAlign="center"
          pt={{ base: 6, md: 10 }}
          pb={4}
          px={{ base: 4, md: 10, lg: 16 }}
          flexShrink={0}
        >
          <Image
            src="/gwbi_logo_red.png"
            alt="GWBI"
            boxSize={{ base: "70px", md: "90px" }}
            mx="auto"
          />
          {title && (
            <Heading size="md" color="white">
              {title}
            </Heading>
          )}
          {subtitle && (
            <Text color="gray.200" fontSize="sm" maxW="480px">
              {subtitle}
            </Text>
          )}
        </VStack>

        {/* Form card */}
        <Flex
          flex="1"
          minH={0}
          px={{ base: 4, md: 10, lg: 16 }}
          pb={{ base: 4, md: 6 }}
        >
          <Flex
            direction="column"
            width={{ base: "100%", md: "560px" }}
            mx="auto"
            p={{ base: 4, md: 6 }}
            borderRadius="lg"
            bg="rgba(255, 255, 255, 0.25)"
            backdropFilter="blur(10px)"
            border="1px solid rgba(255, 255, 255, 0.3)"
            boxShadow="0 4px 30px rgba(0, 0, 0, 0.2)"
            minH={0}
          >
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
